import React, { useEffect, useState } from 'react';

export const hasMetadataValue = (value) => value !== undefined && value !== null && String(value).trim() !== '';
export const mergeMetadataSuggestions = (current, suggestions, protectedFields) => ({
  ...suggestions,
  ...Object.fromEntries(Object.entries(current).filter(([key]) => protectedFields[key])),
});

export default function MetadataReview({ fields, values = {}, logs = [], reviewed = {}, onChange, onValidate, file, errors = {}, analyzed = false }) {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!file) { setUrl(''); return undefined; }
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);
  const captureLogs = Array.isArray(logs) ? logs : [];
  const matches = captureLogs.flatMap((log) => log.matches || []);
  const extractionErrors = captureLogs.flatMap((log) => log.errors || []);
  const extractionFailed = analyzed && captureLogs.length > 0 && captureLogs.every((log) => ['failed', 'unsupported'].includes(log.status));
  const found = fields.filter((field) => hasMetadataValue(values[field.key])).length;
  const checked = fields.filter((field) => reviewed[field.key] && hasMetadataValue(values[field.key])).length;
  return (
    <div className="metadata-review">
      <p className="metadata-summary" role="status">{found} renseignée(s) · {found - checked} à vérifier · {fields.length - found} manquante(s) · {checked} validée(s)</p>
      {extractionErrors.length > 0 && <p className="archive-create-error" role="alert">Analyse du document incomplète : {extractionErrors.join(' · ')}</p>}
      <div className={`metadata-review-layout ${url ? 'has-document' : ''}`}>
        {url && <div className="metadata-document">
          {file.type === 'application/pdf' ? <iframe title="Document à vérifier" src={url} />
            : file.type.startsWith('image/') ? <img src={url} alt="Document à vérifier" /> : <p>Aperçu indisponible pour ce format.</p>}
          <a href={url} target="_blank" rel="noreferrer">Ouvrir le document dans un onglet</a>
        </div>}
        <div className="metadata-review-fields">
          {fields.map((field) => {
            const value = values[field.key];
            const present = hasMetadataValue(value);
            const match = [...matches].reverse().find((item) => item.key === field.key);
            const status = reviewed[field.key] && present ? 'Validé' : present ? 'À vérifier' : extractionFailed ? 'Analyse impossible' : analyzed ? 'Non détecté' : 'À renseigner';
            const id = `metadata-review-${field.key}`;
            return <div className="metadata-field-card" key={field.key}>
              <div className="metadata-field-heading"><label htmlFor={id}>{field.label || field.key}{field.required ? ' *' : ''}</label><span className="metadata-status">{status}</span></div>
              {onChange ? field.type === 'boolean' ? <select id={id} className="form-control" value={present ? String(value) : ''} onChange={(e) => onChange(field.key, e.target.value)} aria-invalid={!!errors[`metadata:${field.key}`]}>
                <option value="">Choisir</option><option value="true">Oui</option><option value="false">Non</option>
              </select> : <input id={id} className="form-control" type={field.type === 'date' ? 'date' : field.type === 'number' ? 'number' : 'text'} step={field.type === 'number' ? 'any' : undefined} value={present ? String(value) : ''} onChange={(e) => onChange(field.key, e.target.value)} aria-invalid={!!errors[`metadata:${field.key}`]} />
                : <p>{present ? String(value) : 'Aucune valeur trouvée'}</p>}
              {errors[`metadata:${field.key}`] && <p className="archive-create-error" role="alert">{errors[`metadata:${field.key}`]}</p>}
              {match && <details><summary>Voir l’extrait détecté</summary><blockquote>{match.line || match.match}</blockquote><small>{match.keyword ? `Mot-clé : ${match.keyword}` : 'Détection par règle avancée'}</small></details>}
              {onValidate && present && !reviewed[field.key] && <button type="button" className="btn btn-sm" onClick={() => onValidate(field.key)}>Valider cette valeur</button>}
            </div>;
          })}
        </div>
      </div>
    </div>
  );
}
